export default "__VITE_ASSET__YlpL0aNV__"